import { render } from "./RecuperoCredito.vue?vue&type=template&id=dec486d2&scoped=true"
import script from "./RecuperoCredito.vue?vue&type=script&lang=js"
export * from "./RecuperoCredito.vue?vue&type=script&lang=js"

import "./RecuperoCredito.vue?vue&type=style&index=0&id=dec486d2&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dec486d2"]])

export default __exports__